import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PlanCreatePage } from '@/modules/plans/pages/PlanCreatePage';

const planCreateSearchSchema = z.object({
  productId: z.string().uuid().optional(),
});

export const Route = createFileRoute('/dashboard/plans/new')({
  validateSearch: (search) => planCreateSearchSchema.parse(search),
  component: PlanCreatePageRoute,
});

function PlanCreatePageRoute() {
  const { productId } = Route.useSearch();
  return <PlanCreatePage {...(productId ? { productId } : {})} />;
}
